import queryTypes from '../constants/usage';
import { commonEvents, dateColumns } from '../constants/event';

// eslint-disable-next-line import/prefer-default-export
export const getUsageEventName = (queryType, groupColumn) => {
  if (queryType === queryTypes.USERS) {
    switch (groupColumn) {
      case dateColumns.HOUR:
        return commonEvents.DAU;
      case dateColumns.DAY:
        return commonEvents.DAU;
      case dateColumns.WEEK:
        return commonEvents.WAU;
      case dateColumns.MONTH:
        return commonEvents.MAU;

      default:
        return undefined;
    }
  } else {
    return commonEvents.SESSION_CLOSE;
  }
};
